import {
  FAILURE,
  PENDING
} from '../../utils/status';

// trip 对象
export function trip(state, trip_id) {
  let tripMap = state.entity.trip;
  let id = state.trip.detail.data;

  if (id === trip_id) {
    return tripMap[id];
  } else {
    return;
  }
}

// selectedDay
export function day(state, trip) {
  let day = state.trip.selectedDay;

  if (day < 0) day = 0;
  if (trip && trip.trip_days < day) day = trip.trip_days;

  return day;
}

// init status
export function initStatus(state, trip) {
  let status = state.trip.detail.status;

  // 因为localState可能会保存上次成功请求
  if (status === FAILURE) {
    return status;
  } else if (!trip) {
    return PENDING;
  } else {
    return status;
  }
}


export function route(state) {
  return state.route.route.data;
}

export function routeStatus(state) {
  return state.route.route.status;
}

export function fullTripRoute(state) {
  return state.route.fullTripRoute.data;
}

export function fullTripRouteStatus(state) {
  return state.route.fullTripRoute.status;
}


export function order(state) {
  return state.order.tripOrder.data;
}



// WEBPACK FOOTER //
// ./src/pages/trip/selector.js